// extracted by mini-css-extract-plugin
export var contentBody = "_47-9";
export var headerImage = "_47-2";
export var imageButton = "_47-7";
export var imageButtonIcon = "_47-8";
export var imageHeader = "_47-4";
export var imageHeaderText = "_47-5";
export var imageOverlay = "_47-3";
export var imageTitle = "_47-6";
export var imageWrapper = "_47-1";
export var taskList = "_47-a";
export var widget = "_47-0";